module.exports = __webpack_public_path__ + "img/Icon-Medications.a67fb78d.svg";